import { connect } from 'react-redux';
import ConsentRequestsCard from './ConsentRequestsCard';
import { getTranslation } from "../../../reducers/common/localization";
import { getCurrentConsentRequestId, setCurrentConsentRequest } from "../../../reducers/consent/organizationConsents";

const mapStateToProps = (state, {id}) => {
    return {
        isActive: getCurrentConsentRequestId(state) === id,
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onSelectConsentRequest: (id) => dispatch(setCurrentConsentRequest(id))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConsentRequestsCard);



// WEBPACK FOOTER //
// ./src/components/organizationConsentManagement/consentRequestCard/ConsentRequestsCard.container.js